import React from 'react';
import {
  LayoutPicker,
  WIDGET_OUTLINE_EFFECT,
} from '@pulsoid-private/widgets-lib';
import {Col, Form, Row} from 'react-bootstrap';
import ColorPicker from '../ColorPicker';

export const ContainerConfiguration = ({
  configuration,
  updateConfiguration,
}) => {
  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Layout
        </Form.Label>
        <Col sm="3">
          <LayoutPicker
            selectedItem={configuration.layout || null}
            onSelect={(layout) => updateConfiguration({layout})}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Outline
        </Form.Label>

        <Form.Group as={Col} sm="3">
          <Form.Label>Effect</Form.Label>
          <Form.Control
            as="select"
            value={configuration.outline?.effect || 'none'}
            onChange={(e) =>
              updateConfiguration({
                outline: {
                  ...(configuration.outline || {}),
                  effect: e.target.value,
                },
              })
            }
          >
            {Object.values(WIDGET_OUTLINE_EFFECT).map((effect) => (
              <option key={effect} value={effect}>
                {effect}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        {configuration.outline?.effect &&
          configuration.outline?.effect !== 'None' && (
            <Form.Group as={Col} sm="3">
              <Form.Label>Effect Color</Form.Label>
              <Form inline>
                <ColorPicker
                  color={configuration.outline?.color}
                  onChangeComplete={(color) =>
                    updateConfiguration({
                      outline: {
                        ...(configuration.outline || {}),
                        color,
                      },
                    })
                  }
                />
              </Form>
            </Form.Group>
          )}
      </Form.Group>
    </>
  );
};
